import React from 'react';

interface SidebarTooltipProps {
  label: string;
}

const SidebarTooltip: React.FC<SidebarTooltipProps> = ({ label }) => {
  return (
    <div className="pointer-events-none absolute bottom-0 left-20 z-[50] ml-2 opacity-0 transition-all duration-200 ease-in-out group-hover:translate-x-1 group-hover:opacity-100">
      <div className="whitespace-nowrap rounded-md border border-gray-700 bg-gray-900 px-3 py-1.5 text-xs font-medium text-white shadow-xl">
        {label}
      </div>
    </div>
  );
};

export default SidebarTooltip;
